import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { NgxSpinnerService } from 'ngx-spinner';

import { NotificationService, FieldMapItem } from 'beyond-util';

import { BackendService } from '../../../../services/backend.service';
import { FormCode } from '../../../../enums/form-code.enum';
import { FormName } from '../../../../enums/form-name.enum';
import { EndpointTypes } from '../../../../enums/enpoint-types.enum';

@Injectable()
export class KorisniciService {
  private _fetchListSettings: Subject<any> = new Subject<any>();
  public fetchListSettings$: Observable<
    any
  > = this._fetchListSettings.asObservable();

  private _fetchDetailsSettings: Subject<any> = new Subject<any>();
  public fetchDetailsSettings$: Observable<
    any
  > = this._fetchDetailsSettings.asObservable();

  private _createEntity: Subject<any> = new Subject<any>();
  public createEntity$: Observable<any> = this._createEntity.asObservable();

  private _updateEntity: Subject<any> = new Subject<any>();
  public updateEntity$: Observable<any> = this._updateEntity.asObservable();

  private _deleteEntity: Subject<any> = new Subject<any>();
  public deleteEntity$: Observable<any> = this._deleteEntity.asObservable();

  constructor(
    private _backendService: BackendService,
    private _notificationService: NotificationService,
    private _spinner: NgxSpinnerService
  ) {}

  fetchListSettings(filter: string) {
    this._backendService
      .fetchSettings(
        FormCode.MSKOR_KOR,
        FormName.AdministracijaKorisnika,
        EndpointTypes.AllEntities,
        filter
      )
      .toPromise()
      .then(response => {
        if (this.hasError(response)) {
          return;
        }

        this._fetchListSettings.next(response);
      });
  }

  fetchDetailsSettings(formCode: FormCode, orderId: any) {
    this._backendService
      .fetchSettings(
        formCode,
        FormName.AdministracijaKorisnika,
        EndpointTypes.SingleEntity,
        '',
        orderId
      )
      .toPromise()
      .then(response => {
        if (this.hasError(response)) {
          return;
        }

        this._fetchDetailsSettings.next(response);
      });
  }

  create(order: any, uloge: any[]) {
    const payload: any = { ...order };
    payload.UlogeIds = uloge.map(u => u['Naziv']);

    this._backendService
      .save(FormCode.MSKOR_KOR, FormName.AdministracijaKorisnika, payload)
      .toPromise()
      .then(response => {
        if (this.hasError(response)) {
          return;
        }

        this._createEntity.next(response);
      });
  }

  update(order: any, uloge: any[]) {
    const payload: any = { ...order };
    payload.UlogeIds = uloge.map(u => u['Naziv']);

    this._backendService
      .update(FormCode.MSKOR_KOR, FormName.AdministracijaKorisnika, payload)
      .toPromise()
      .then(response => {
        if (this.hasError(response)) {
          return;
        }

        this._updateEntity.next(response);
      });
  }

  delete(orderId: any) {
    this._backendService
      .delete(FormCode.MSKOR_KOR, FormName.AdministracijaKorisnika, orderId)
      .toPromise()
      .then(response => {
        if (this.hasError(response)) {
          return;
        }

        this._notificationService.openNoty('Uspešno brisanje');
        this._deleteEntity.next();
      });
  }

  getUloge(response: any, orderId: any) {
    return orderId
      ? response.ServiceData[0].Uloge.map(uloga => {
          return {
            rbr: uloga.Id,
            Id: uloga.Id,
            Naziv: uloga.Id,
          };
        })
      : [];
  }

  alterMandatoryFields(field: FieldMapItem, isMandatory: boolean): void {
    field.mandatory = isMandatory;
  }

  hasError(response: any) {
    const hasError = response['Error'] && response['Error']['ErrorMessage'];

    if (hasError) {
      this._spinner.hide();
      this.notifyError(response['Error']['ErrorMessage']);
    }

    return hasError;
  }

  notifyError(message: string) {
    this._notificationService.notyError(message);
  }

  alterSettings(data: any) {
    data['Settings'].inlineAdding = false;
    data['Settings'].inlineEditing = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/sifarnici/korisnici/services/korisnici.service.ts